export default {
	methods: {
		loadData() {
			return this.get('/load-data');
		},
		loadGameData() {
			return this.get('/load-game-data');
		},
	}
}
